import cx from 'classnames';
import { useGetCommentsFromParent } from 'pages/comments/hooks/useGetCommentsFromParent';
import { idToUri } from 'pages/global/UriHelper';
import { ChatFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { TagColor } from './TagColor';

export function CommentButton({ uri, parentUri, handleMetaClick, entity }) {
    const { t } = useTranslation('documents');
    const { comments, unresolvedComments } = useGetCommentsFromParent(parentUri, [uri]);

    const blockIds = entity.blockIds ?? [];
    const hasUnresolvedComments = unresolvedComments.length > 0;

    return (
        <>
            {comments.length > 0 && (
                <div
                    className="position-absolute cursor-pointer"
                    style={{
                        top: -10,
                        right: -10,
                        width: 18,
                        height: 18,
                        lineHeight: '18px',
                    }}
                    onClick={() => handleMetaClick('comments')}
                    data-uk-tooltip={t('document.navbar.main.editor.left.blocks.settingsSidebar.tootltips.comments')}
                >
                    <ChatFill
                        size={18}
                        style={{
                            width: 18,
                            height: 18,
                            position: 'absolute',
                        }}
                        className={cx({
                            'text-info': !hasUnresolvedComments,
                            'text-warning': hasUnresolvedComments,
                        })}
                    />

                    <TagColor uri={uri} comments={comments} />

                    {hasUnresolvedComments && (
                        <span
                            className="position-absolute text-center"
                            style={{
                                width: 18,
                                height: 16,
                                fontSize: unresolvedComments.length > 99 ? 8 : 10,
                                color: 'white',
                            }}
                        >
                            {unresolvedComments.length}
                        </span>
                    )}
                </div>
            )}

            {blockIds.length > 0 && (
                <BlockBalloons parentUri={parentUri} uris={blockIds.map((blockId) => idToUri(blockId, 'Block'))} />
            )}
        </>
    );
}

function BlockBalloons({ parentUri, uris = [] }) {
    const { t } = useTranslation('documents');
    const { comments, unresolvedComments } = useGetCommentsFromParent(parentUri, uris);

    if (comments.length === 0) {
        return null;
    }

    const hasUnresolvedComments = unresolvedComments.length > 0;

    return (
        <div
            className="position-absolute"
            style={{
                bottom: 2,
                right: -8,
            }}
            data-uk-tooltip={t('document.navbar.main.editor.left.blocks.settingsSidebar.tootltips.blockComment')}
        >
            <ChatFill
                size={12}
                className={cx({
                    'text-info': !hasUnresolvedComments,
                    'text-warning': hasUnresolvedComments,
                })}
            />
        </div>
    );
}
